<div edlFocusTrap class="focus-trap-container">
<div class="modal-header">
    <div class="row">
        <div class="col-12">
            <h4 class="modal-title">{{title}}</h4>
        </div>
        <div class="col-12 d-lg-none">
            <edl-floating-label-container label="Navigate to section" for="detailsNavigation"  >
                <select id="detailsNavigation" (ngModelChange)="loadComponent($event)" [ngModel]="selectedItem" class="form-select">
                    <optgroup *ngFor="let navigationSection of navigationSections; index as sectionIndex" [label]="navigationSection.title">
                        <option *ngFor="let item of navigationSection.navigationItems; index as itemIndex" [ngValue]="item">
                            {{StringHelpers.truncate(item.label, 30)}}
                        </option>
                </select>
            </edl-floating-label-container>
        </div>
    </div>
</div>
<div class="modal-body details-container">
    <div class="details-navigation d-none d-lg-block">
            <div *ngFor="let navigationSection of navigationSections" class="row"> 
                <h5>{{navigationSection.title}}</h5>   
                <ul class="flex-column list-group list-group-flush">
                    <li class="list-group-item d-flex align-items-center flex-row"
                        [class.highlight]="this.selectedItem === item"
                        *ngFor="let item of navigationSection.navigationItems"  >
                        <i *ngIf="item.required" class="fas fa-asterisk required" ngbTooltip="Required" aria-hidden="true"></i>
                        <button type="button" class="btn btn-link p-0 text-truncate" (click)="loadComponent(item)">{{item.label}}</button></li>
                </ul>
            </div> 
            
    </div>
    <div class="details-content">
        <div class="content" *ngIf="busy" > 
                <div class="loader"></div>
        </div>
        <div #userdetails></div> 
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-sm btn-info"
        (click)="close()">Close</button>
</div>
</div>
